module.exports = require("@aws-sdk/client-dynamodb");